export const toUsFormat = (number: number) => number.toLocaleString('en', { minimumFractionDigits: 2 });

export const roundUpToNext1000 = (value: number) => Math.ceil(value / 1000) * 1000;

export const calculate = (
    filingSatus: string,
    children: number,
    childreSixPlus: number,
    income: number,
  ) => {

  const A = childreSixPlus; // Number of Children Age 6 to 17 as of December 31, 2021
  const B = children; // Number of Children Age 5 and Under as of December 31, 2021
  const C = income; // Adjusted Gross Income (AGI) for 2020 (or 2019 if 2020 is not available)

  let D; // 2021 Increase Phase-Out Threshold

  switch (filingSatus) {
    case "married-jointly":
    case "widower":
      D = 150000;
      break;
    case "head-houshold":
      D = 112500;
      break;
    case "single":
    case "married-separately":
      D = 75000;
      break;
    default:
      D = 0;
  }

  let E; // Current Phase-Out Thresholds
  switch (filingSatus) {
    case "married-jointly":
      E = 400000;
      break;
    case "head-houshold":
    case "single":
    case "married-separately":
    case "widower":
      E = 200000;
      break;
    default:
      E = 0;
  }

  // STEP 1
  const initialCredit = (A * 3000) + (B * 3600);

  // STEP 2
  const smallerValue = Math.min((A * 1000) + (B * 1600), (E - D) * 0.05);

  const initialReduction = Math.max(roundUpToNext1000(C - D), 0) * 0.05;

  const reducedCredit = initialCredit - (initialReduction > smallerValue ? smallerValue : initialReduction);

  // STEP 3
  const secondReduction = Math.max(roundUpToNext1000(C - E), 0) * 0.05;
  const finalCredit = (C < E) ? reducedCredit : reducedCredit - secondReduction;

  // STEP 4
  const monthlyPayment = Math.max(Math.round(finalCredit * 0.08333), 0);

  // STEP 5
  const creditAmount = Math.max(Math.round(finalCredit * 0.5), 0);

  return {
    initialCredit,
    finalCredit,
    monthlyPayment,
    reducedCredit,
    initialReduction,
    creditAmount,
    secondReduction,
  };
};

// for jest tests
export const getNumberFromEvent = (event: any, isInt = true) => {
  const str = event.target.value.toString().replace(/,/g, '');
  const value = isInt ? Number.parseInt(str, 10) : Number.parseFloat(str);

  if (Number.isNaN(value)) {
    return '';
  }

  if (value < 0) {
    return 0;
  }

  return value;
};
